import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { Image3D } from '~/domain/patient/image3d';
import { environmentState } from '~/state/atoms/engineAtoms';
import { defaultWindowLevelState, windowLevelState } from '~/state/atoms/toolsAtoms';

export default function useWindowLevel() {
    const environment = useRecoilValue(environmentState);
    const setDefaultWindowLevel = useSetRecoilState(defaultWindowLevelState);
    const imageSeriesInstanceUID = environment?.image?.seriesInstanceUID;

    const [currentWindowLevel, setCurrentWindowLevel] = useRecoilState(windowLevelState);

    const setUpWindowLevelContext = (image: Image3D) => {
        const imageDefaultWindowLevel = image.getDefaultWindowLevel();
        setDefaultWindowLevel(imageDefaultWindowLevel);
        image.windowLevel ??= imageDefaultWindowLevel;
        setCurrentWindowLevel(image.windowLevel);
    };

    return {
        windowLevel: imageSeriesInstanceUID ? currentWindowLevel : null,
        setWindowLevel: setCurrentWindowLevel,
        setUpWindowLevelContext
    };
}
